/**
 * Emergency Escape Handler
 * Forces all modals and overlays to close
 * Can be triggered via keyboard shortcut or programmatically
 */

export const forceCloseAllModals = () => {
  // Remove all elements with high z-index that might be blocking
  const blockingElements = document.querySelectorAll(
    '[class*="z-[9999]"], [class*="z-[10000]"], [class*="z-[10001]"], [class*="z-[10002]"], [class*="z-[10003]"], [class*="fixed"], [style*="position: fixed"]'
  )
  
  blockingElements.forEach((el) => {
    const element = el as HTMLElement
    // Check if it's a modal/overlay (has fixed positioning and high z-index)
    const styles = window.getComputedStyle(element)
    if (
      styles.position === 'fixed' &&
      (parseInt(styles.zIndex) > 1000 ||
       element.className.includes('bg-black') ||
       element.className.includes('backdrop') ||
       element.className.includes('overlay') ||
       element.className.includes('modal') ||
       element.className.includes('dialog'))
    ) {
      element.remove()
    }
  })
  
  // Also remove any backdrop/overlay divs
  document.querySelectorAll('[class*="backdrop"], [class*="overlay"], [id*="modal"], [id*="dialog"]').forEach((el) => {
    const element = el as HTMLElement
    const styles = window.getComputedStyle(element)
    if (styles.position === 'fixed' && parseInt(styles.zIndex) > 100) {
      element.remove()
    }
  })

  // Also try to dispatch close events
  window.dispatchEvent(new CustomEvent('force-close-all-modals'))
  
  // Remove body overflow hidden and pointer-events blocking
  document.body.style.overflow = ''
  document.body.style.pointerEvents = ''
  
  // Remove any blocking styles from html element
  document.documentElement.style.overflow = ''
  document.documentElement.style.pointerEvents = ''
  
  console.log('🚨 Emergency escape: All modals forced to close')
}

// Set up global keyboard handler
if (typeof window !== 'undefined') {
  // Triple Escape (press Escape 3 times quickly) or Ctrl+Shift+Escape
  let escapeCount = 0
  let escapeTimer: NodeJS.Timeout | null = null

  const handleEscape = (e: KeyboardEvent) => {
    // Ctrl+Shift+Escape - immediate force close
    if (e.key === 'Escape' && e.ctrlKey && e.shiftKey) {
      e.preventDefault()
      e.stopPropagation()
      forceCloseAllModals()
      return
    }

    // Triple Escape - press Escape 3 times within 1 second
    if (e.key === 'Escape') {
      escapeCount++
      if (escapeTimer) clearTimeout(escapeTimer)
      
      if (escapeCount >= 3) {
        e.preventDefault()
        e.stopPropagation()
        forceCloseAllModals()
        escapeCount = 0
        return
      }
      
      escapeTimer = setTimeout(() => {
        escapeCount = 0
      }, 1000)
    }
  }

  // Add listener with capture to catch events before anything else
  window.addEventListener('keydown', handleEscape, { capture: true, passive: false })
  
  // Also expose globally for manual triggering
  ;(window as any).forceCloseAllModals = forceCloseAllModals
  console.log('🚨 Emergency escape handler installed. Press Ctrl+Shift+Escape or triple Escape to force close all modals.')
}

